export default __webpack_public_path__ + "static/media/inactive_delete_icon.8a61fa21.svg";